export const restrictions = {
    MAX_GROUPS_PER_CONTACT: 50,
    MAX_NAME_LENGTH: 40,
    MAX_GROUPS_PER_INVITE: 50,
};

export const permissionChartLink =
    'https://explore.voxie.com/voxiesupport/hc/en-us/articles/groups-franchise-hub-lifecycle-management-toolset';
